import React, { useEffect, useState } from "react";
import "../App.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ModalHistory = ({ show, handleClose }) => {
  const { t } = useTranslation();
  const [historyData, setHistoryData] = useState([]);

  // Fetch data from localStorage
  useEffect(() => {
    try {
      // Ambil history dari localStorage
      const existingHistory =
        JSON.parse(localStorage.getItem("gameBekelHistory")) || [];

      // Sort data berdasarkan ID atau tanggal (misal descending)
      const sortedHistory = existingHistory.sort((a, b) => {
        // Contoh jika ID lebih besar lebih baru, bisa juga gunakan date comparison
        return b.id - a.id;
      });

      // Ambil 10 data terbaru
      const latestHistory = sortedHistory.slice(0, 10);

      setHistoryData(latestHistory);
    } catch (error) {
      console.error("Error accessing local storage:", error);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="modal-overlay-game flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
      <div className="modal-content-game relative bg-gradient-to-r from-orange-400 to-red-400 rounded-3xl shadow-2xl w-full sm:max-w-md md:max-w-2xl lg:max-w-4xl p-4 sm:p-6 md:p-8">
        <button
          onClick={handleClose}
          className="close-button absolute top-2 right-2 px-4 py-3 text-white hover:text-gray-300 font-extrabold text-3xl sm:text-4xl md:text-5xl transform hover:scale-110 transition-transform duration-200"
        >
          &times;
        </button>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 sm:mb-6 text-white tracking-wider">
          {t("game_history")}
        </h2>

        <div className="overflow-x-auto">
          <table className="table-auto border-collapse w-full text-left text-sm sm:text-base md:text-lg bg-white rounded-2xl overflow-hidden">
            <thead className="bg-orange-500 text-white">
              <tr>
                <th className="px-2 sm:px-4 py-2">No</th>
                <th className="px-2 sm:px-4 py-2">{t("date")}</th>
                <th className="px-2 sm:px-4 py-2">Status</th>
                <th className="px-2 sm:px-4 py-2">Level</th>
                <th className="px-2 sm:px-4 py-2">{t("game_score")}</th>
                <th className="px-2 sm:px-4 py-2">{t("english_score")}</th>
              </tr>
            </thead>
            <tbody className="bg-orange-200 text-orange-950">
              {historyData.map((history, index) => (
                <React.Fragment key={index}>
                  <tr key={index} className="transition-colors duration-200">
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {index + 1}
                    </td>
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {history.date}
                    </td>
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {history.status}
                    </td>
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {history.level}
                    </td>
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {history.skorgame}
                    </td>
                    <td className="border border-orange-300 px-2 sm:px-4 py-2">
                      {history.englishscore}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ModalHistory;
